/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TicketUnreadCount } from '../../models/ticket-unread-count';

export interface GetConversationUnreadTicketCount$Params {
  conversationReference: string;
}

export function getConversationUnreadTicketCount(http: HttpClient, rootUrl: string, params: GetConversationUnreadTicketCount$Params, context?: HttpContext): Observable<StrictHttpResponse<TicketUnreadCount>> {
  const rb = new RequestBuilder(rootUrl, getConversationUnreadTicketCount.PATH, 'get');
  if (params) {
    rb.path('conversationReference', params.conversationReference, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TicketUnreadCount>;
    })
  );
}

getConversationUnreadTicketCount.PATH = '/v1/api/ui/manage-ticket/unread-count/{conversationReference}';
